/* eslint-disable react/forbid-prop-types */
import React from "react";
import { Input as InputAntd } from "antd";
import PropTypes from "prop-types";
import FloatLabel from "../FloatLabel";
import { ChangeEventHandler } from "react";
import styles from "./Input.module.less";
//const cx = classnames.bind(styles);

interface Props {
  type: string;
  required?: boolean;
  label: string;
  text: string;
  rules: any;
  error: any; //  FieldError; // Requireable<object>; //{ message: string };
  password: boolean;
  uppercase: string;
  disabled: boolean;
  min: string;
  max: string;
  step?: number;
  placeholder: string;
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  className: string;
  children?: JSX.Element;
}
export default function Input(props: Props) {
  const {
    type,
    required,
    label,
    text,
    rules,
    error,
    password,
    uppercase,
    disabled,
    min,
    max,
    step,
    placeholder,
    onPressEnter,
    onChange,
    className,
    children,
  } = props;

  if (uppercase) {
    props.uppercase = uppercase;
  }

  const Input = password ? InputAntd.Password : InputAntd;

  return (
    <>
      <FloatLabel
        label={label}
        text={""}
        float={true}
        required={!!rules.required}
        className={className}
      >
        <Input
          {...props}
          type={type}
          required={required}
          className={styles["ant-input"]}
          spellCheck={false}
          disabled={disabled}
          min={min}
          max={max}
          onPressEnter={onPressEnter}
          onChange={onChange}
          placeholder={placeholder}
          step={step}
          style={{
            ...(disabled ? { cursor: "default" } : {}),
          }}
          value={text}
        />
        {children}

        {error && <span className="error-msg">{error.name}</span>}
      </FloatLabel>
    </>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  rules: PropTypes.any,
  error: PropTypes.object,
  password: PropTypes.string, // password: PropTypes.bool,
  uppercase: PropTypes.string,
  control: PropTypes.object,
  required: PropTypes.bool,
};

Input.defaultProps = {
  defaultValue: "",
  error: null,
  password: "",
  uppercase: "",
  rules: {},
};
